import React from 'react'
import { FormControl, Select, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import groupFilterStyles from './groupFilter.styles'

const useStyles = makeStyles(groupFilterStyles)

const GroupFilter = ({ selectedStage, selectedGroup, onGroupChange, className }) => {
  const classes = useStyles()

  const groups = selectedStage?.groups || []

  const handleChange = (event) => {
    const groupId = event.target.value
    const group = groups.find((g) => g.id === groupId)
    onGroupChange(group || null)
  }

  if (!selectedStage || groups.length === 0) {
    return null
  }

  return (
    <FormControl className={`${classes.formControl} ${className}`}>
      <Select
        labelId='group-filter-label'
        id='group-filter'
        value={selectedGroup?.id || ''}
        onChange={handleChange}
        displayEmpty
      >
        <MenuItem value=''>
          <em>All Groups</em>
        </MenuItem>
        {groups.map((group) => (
          <MenuItem key={group.id} value={group.id}>
            {group.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default GroupFilter
